import styled from 'styled-components';

import { GENERAL_SECTIONS } from 'components/notificationPreferences/generalSections';
import InboundReferralSectionPreferences from 'components/notificationPreferences/InboundReferralSectionPreferences';
import { BodySmall, H3 } from 'styles/typography';

// The one form key the General row lives under. Its siblings are the care-coordination rows,
// keyed by group-type ids (uuids), and the inbound-referrals key, so it never collides.
export const GENERAL_FORM_KEY = 'general';

function GeneralPreferencesContainer({ disabled = false }: { disabled?: boolean }) {
  return (
    <Container>
      <SelectSection>
        <StyledH3>Select Notifications</StyledH3>
        <SectionDescription>
          The following notifications are not specific to one area of Olio and apply generally across the application.
        </SectionDescription>
        {GENERAL_SECTIONS.map((section) => (
          <InboundReferralSectionPreferences
            key={section.category}
            section={section}
            formKey={GENERAL_FORM_KEY}
            testIdPrefix='general-section'
            disabled={disabled}
          />
        ))}
      </SelectSection>
    </Container>
  );
}

const Container = styled.div`
  max-width: 900px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SelectSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledH3 = styled(H3)`
  margin-bottom: 12px;
`;

const SectionDescription = styled(BodySmall)`
  font-size: 12px;
  margin-bottom: 24px;
`;

export default GeneralPreferencesContainer;
